const phoneFieldNormalize = (value) => {
  const rules = [
    // {
    //   re: /^\+8/g,
    //   replacer: '+7',
    // },
    {
      re: /(\D)/g,
      replacer: '',
    },
    {
      re: /^(.*)$/g,
      replacer: function (digits) {
        return digits ? '+' + digits : ''
      },
    },
    {
      re: /\s+$/g,
      replacer: '',
    },
  ]

  return rules
    .reduce(
      (value, rule) => value.replace(new RegExp(rule.re), rule.replacer),
      value,
    )
    .trim()
}

export default phoneFieldNormalize
